import i18n, { getLanguageHeader } from '@/i18n'

class APIRequest {
  url: string
  data: any
  headers: Record<string, string>

  constructor(
    baseUrl: string,
    path: string,
    data: any = {},
    headers: Record<string, string> = {}
  ) {
    this.url = baseUrl + '/api/v1' + path
    this.data = data
    this.headers = {
      ...getLanguageHeader(),
      ...headers,
    }
  }
}

export default APIRequest
